import EditPassword from '@piconetworks/account'
import withInjection from '@piconetworks/with-injection'
import { bindActionCreators } from 'redux'

import Internal from 'common/modules/internal'
import Loader from 'common/modules/loader'
import Account from 'common/modules/account'
import xFrame from 'common/xFrame'

import WizardRedux from 'common/pkgs/WizardRedux'

let userHasPasswordOnMount

const mapStateToProps = (state, props) => {
    if (typeof userHasPasswordOnMount === 'undefined') {
        userHasPasswordOnMount = Loader.selectors.userHasPassword(state)
    }

    return {
        ...props,
        userHasPassword: Loader.selectors.userHasPassword(state),
        publisherId: Loader.selectors.publisherId(state),
        userLoader: state.loader.user,
        skipWizardSubmit: true,
        type: 'password',
        hideDefaultSubmitButtons: true,
        account: state.account,
        WizardRedux,
    }
}

const mapDispatchToProps = (dispatch) => ({
    onUpdateSuccess: ({ firstTimePassword }) => {
        userHasPasswordOnMount = true

        xFrame.prompt.showPaswordUpdated({
            dispatch,
            firstTimePassword,
        })

        dispatch(Account.creators.initialize())

        dispatch(Internal.creators.sendMessage({
            payload: {
                target: 'pico_arbiter',
                type: 'LOADER/INVALIDATION_EVENT',
                scope: [
                    'user',
                ],
            },
        }))
    },
    ...bindActionCreators({
        updateLoaderUser: Loader.creators.updateLoaderUser,
        initialize: Account.creators.initialize,
    }, dispatch),
    update: (payload) => Internal.helpers.invalidateLoader({
        payload,
        action: Account.creators.update,
        dispatch,
    }),
})

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const { onUpdateSuccess } = dispatchProps

    return {
        ...ownProps,
        ...stateProps,
        ...dispatchProps,
        onUpdateSuccess: () => {
            onUpdateSuccess({
                firstTimePassword: !userHasPasswordOnMount,
            })

            stateProps.router.push({
                pathname: '/',
            })
        },
    }
}

const InjectedEditPassword = withInjection(EditPassword, {
    mapStateToProps,
    mapDispatchToProps,
    mergeProps,
})

export default InjectedEditPassword
